if (!customElements.get('add-on-info')) {
	customElements.define('add-on-info',
		class AddOnInfo extends HTMLElement {
			abortController = undefined;
			pendingRequestUrl = null;
			preProcessHtmlCallbacks = [];
			postProcessHtmlCallbacks = [];
			cartUpdateUnsubscriber = undefined;
			currentVariant = null;

			constructor() {
				super();
				this.handleOptionValueChange = this.handleOptionValueChange.bind(this);
			}

			get productForm() {
				return this.querySelector('form[is="add-on-form"]');
			}

			// connectedCallback() {
			// 	this.addEventListener('optionValueSelectionChange', this.handleOptionValueChange);

			// 	let variant = this.getSelectedVariant(this);

			// 	if (!variant) {
			// 		const selects = this.querySelectorAll('add-on-variant-selects select');
			// 		selects.forEach(select => {
			// 			if (!select.value && select.options.length > 0) {
			// 				select.selectedIndex = 0;
			// 				select.dispatchEvent(new Event('change', { bubbles: true }));
			// 			}
			// 		});

			// 		const radios = this.querySelectorAll('add-on-variant-selects input[type="radio"]');
			// 		const groupedByName = {};

			// 		radios.forEach(input => {
			// 			if (!groupedByName[input.name]) groupedByName[input.name] = [];
			// 			groupedByName[input.name].push(input);
			// 		});

			// 		Object.values(groupedByName).forEach(group => {
			// 			const checked = group.find(input => input.checked);
			// 			if (!checked && group.length) {
			// 				group[0].checked = true;
			// 				group[0].dispatchEvent(new Event('change', { bubbles: true }));
			// 			}
			// 		});

			// 		variant = this.getSelectedVariant(this);
			// 	}

			// 	this.currentVariant = variant;

			// 	if (variant) {
			// 		this.updateVariantInputs(variant.id);
			// 		this.updateAddOnDisplay(variant);

			// 		const allVariantsData = this.querySelector('[data-add-on-variants]')?.innerHTML;
			// 		const allVariants = allVariantsData ? JSON.parse(allVariantsData) : [];

			// 		this.updateOptionAvailability(variant, allVariants);

			// 		const variantSelects = this.querySelector('add-on-variant-selects');
			// 		if (!variantSelects) return;

			// 		const inputsWrappers = variantSelects.querySelectorAll('.add-on__input');

			// 		inputsWrappers.forEach(wrapper => {
			// 			const select = wrapper.querySelector('select');
			// 			const checkedInput = wrapper.querySelector('input[type="radio"]:checked');

			// 			if (select) {
			// 				select.dispatchEvent(new Event('change', { bubbles: true }));
			// 			} else if (checkedInput) {
			// 				checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
			// 			}
			// 		});
			// 	}
			// }

			connectedCallback() {
				this.addEventListener('optionValueSelectionChange', this.handleOptionValueChange);

				let variant = this.getSelectedVariant(this);
				console.log(variant)
				this.currentVariant = variant;
				console.log(this.currentVariant)
				if (variant) {
					this.updateVariantInputs(variant.id);
					this.updateAddOnDisplay(variant);

					const allVariantsData = this.querySelector('[data-add-on-variants]')?.innerHTML;
					const allVariants = allVariantsData ? JSON.parse(allVariantsData) : [];

					this.updateOptionAvailability(variant, allVariants);

					const variantSelects = this.querySelector('add-on-variant-selects');
					if (!variantSelects) return;

					const firstFieldset = variantSelects.querySelector('fieldset');
					if (firstFieldset) {
						const firstInput = firstFieldset.querySelector('input:not(:disabled)');
						if (firstInput) {
							firstInput.checked = true;
							firstInput.dispatchEvent(new Event('change', { bubbles: true }));
							console.log('Автоматичний клік на:', firstInput);
						}
					}
				}
			}


			disconnectedCallback() {
				this.removeEventListener('optionValueSelectionChange', this.handleOptionValueChange);
			}

			handleOptionValueChange({ detail }) {
				const { event, target } = detail;

				if (!this.contains(event.target)) return;

				const variant = this.getSelectedVariant(this);
				this.currentVariant = variant;
				this.updateVariantInputs(variant?.id);


				if (variant) {
					this.updateAddOnDisplay(variant);

					const allVariantsData = this.querySelector('[data-add-on-variants]')?.innerHTML;
					const allVariants = allVariantsData ? JSON.parse(allVariantsData) : [];

					this.updateOptionAvailability(variant, allVariants);
				}
			}

			getSelectedVariant(node) {
				const allVariantsData = node.querySelector('[data-add-on-variants]')?.innerHTML;
				if (!allVariantsData) return null;

				const variants = JSON.parse(allVariantsData);
				const variantSelects = this.querySelector('add-on-variant-selects');
				if (!variantSelects) return null;

				const selects = variantSelects.querySelectorAll('select');
				const radiosGroups = variantSelects.querySelectorAll('fieldset');

				const selectedOptions = [];

				selects.forEach(select => {
					selectedOptions.push(select.value);
				});

				radiosGroups.forEach(group => {
					const checked = group.querySelector('input[type="radio"]:checked');
					selectedOptions.push(checked?.value || null);
				});

				return variants.find(variant =>
					selectedOptions.every((opt, idx) => variant[`option${idx + 1}`] === opt)
				);
			}

			updateVariantInputs(variantId) {
				if (!variantId) return;
				const input = this.productForm?.querySelector('input[name="id"]');
				if (input) {
					input.value = variantId;
				}
			}

			updateAddOnDisplay(variant) {
				const productId = this.dataset.productId;
				if (!productId) return;

				const item = document.querySelector(`.add-on__item[data-id="${productId}"]`);
				if (!item) return;

				const checkbox = item.querySelector('[data-add-on-checkbox]');
				if (checkbox) checkbox.value = variant.id;

				const hiddenInput = item.querySelector('input[name="add_ons[]"]');
				if (hiddenInput) hiddenInput.value = variant.id;

				const optionsContainer = item.querySelector('.add-on__product-options');
				if (optionsContainer) {
					const options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
					optionsContainer.innerHTML = options.map((opt, i) => {
						const isLast = i === options.length - 1;
						return `<span>${opt}${isLast ? '' : ', '}</span>`;
					}).join('');
				}

				const pricesContainer = item.querySelector('.prices');
				if (pricesContainer) {
					const compareAtPriceEl = pricesContainer.querySelector('.compare_at_price');
					const regularPriceEl = pricesContainer.querySelector('.regular-price');

					if (variant.compare_at_price > variant.price) {
						if (compareAtPriceEl) {
							compareAtPriceEl.textContent = this.formatMoney(variant.compare_at_price);
							compareAtPriceEl.style.display = '';
						}
					} else if (compareAtPriceEl) {
						compareAtPriceEl.style.display = 'none';
					}

					if (regularPriceEl) {
						regularPriceEl.textContent = this.formatMoney(variant.price);
					}
				}
			}

			formatMoney(cents) {
				const dollars = cents / 100;
				return `$${dollars.toFixed(2)}`;
			}

			updateOptionAvailability(variant, allVariants) {
				const selects = this.querySelectorAll('add-on-variant-selects fieldset');

				selects.forEach((fieldset, optionIndex) => {
					const inputs = fieldset.querySelectorAll('input[type="radio"]');

					inputs.forEach((input) => {
						const value = input.value;

						const selectedOptions = Array.from(this.querySelectorAll('add-on-variant-selects select, add-on-variant-selects input:checked'))
							.map((el) => el.value);

						const testOptions = [...selectedOptions];
						testOptions[optionIndex] = value;

						const matchingVariant = allVariants.find(v =>
							testOptions.every((opt, i) => v[`option${i + 1}`] === opt));

						if (matchingVariant && matchingVariant.available) {
							input.disabled = false;
							input.closest('label')?.classList.remove('disabled');
						} else {
							input.disabled = true;
							input.closest('label')?.classList.add('disabled');
						}
					});
				});
			}
	});
}

if (!customElements.get('add-on-variant-selects')) {
	customElements.define(
		'add-on-variant-selects',
		class AddOnVariantSelects extends HTMLElement {
			constructor() {
				super();
			}

			get selectedOptionValues() {
				return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
					({ dataset }) => dataset.optionValueId
				);
			}

			getInputForEventTarget(target) {
				return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
			}

			connectedCallback() {
				this.addEventListener('change', (event) => {
					const target = this.getInputForEventTarget(event.target);
					this.updateSelectedSwatchValue(event);

					const addOnInfo = this.closest('add-on-info');

					if (addOnInfo) {
						addOnInfo.dispatchEvent(new CustomEvent('optionValueSelectionChange', {
							detail: {
								event,
								target,
								selectedOptionValues: this.selectedOptionValues,
							},
							bubbles: false,
						}));
					}
				});
			}

			updateSelectedSwatchValue({ target }) {
				const inputWrapper = target.closest('.add-on__input');
				const labelSpan = inputWrapper?.querySelector('[data-add-on-selected-swatch-value]');
				if (!labelSpan) return;

				if (target.tagName === 'SELECT') {
					const selectedOption = target.selectedOptions[0];
					labelSpan.innerHTML = selectedOption?.textContent || '';
				} else if (target.tagName === 'INPUT' && target.type === 'radio') {
					labelSpan.innerHTML = target.value;
				}
			}
		}
	);
}